import usePackageVersion from '@/hooks/usePackageVersion';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import LanguageSwitcher from '../LanguageSwitcher';

interface FooterProps {
  onOpenPrivacySettings?: () => void;
}

const Footer: React.FC<FooterProps> = ({ onOpenPrivacySettings = () => {} }) => {
  const { t } = useTranslation('layout');
  const version = usePackageVersion();
  const year = new Date().getFullYear();
  const contactLabel = t('footer.contactLabel');
  const companyName = t('footer.company');
  const contactEmail = t('footer.email');

  return (
    <footer className="app-footer" role="contentinfo">
      <div className="container app-footer__inner">
        <span>{t('footer.rights', { year })}</span>
        <address
          className="app-footer__contact"
          aria-label={typeof contactLabel === 'string' ? contactLabel : undefined}
        >
          <span className="app-footer__company">{companyName}</span>
          <a className="app-footer__email" href={`mailto:${contactEmail}`}>
            {contactEmail}
          </a>
        </address>
        <div className="app-footer__meta">
          <span className="app-footer__version">{t('footer.version', { version })}</span>
          <LanguageSwitcher variant="outline-light" />
        </div>
        <nav className="app-footer__legal" aria-label={t('footer.legalLinksLabel')}>
          <Link to="/legal/privacy-policy" className="app-footer__legal-link">
            {t('footer.privacyPolicy')}
          </Link>
          <Link to="/legal/cookie-policy" className="app-footer__legal-link">
            {t('footer.cookiePolicy')}
          </Link>
          <button
            type="button"
            className="app-footer__legal-button"
            onClick={onOpenPrivacySettings}
          >
            {t('footer.privacySettings')}
          </button>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
